import * as React from 'react';
import { SVGProps } from 'react';

const IconPictureSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 9.889V2.11C11 1.5 10.5 1 9.889 1H2.11C1.5 1 1 1.5 1 2.111V9.89C1 10.5 1.5 11 2.111 11H9.89C10.5 11 11 10.5 11 9.889ZM4.056 6.833l1.388 1.673L7.39 6l2.5 3.333H2.11l1.945-2.5Z" />
  </svg>
);
export default IconPictureSizeXs;
